<template>
    <div v-if="loading" class="page-center">
        <div class="page-center-box text-center">
            <ui-loading-page />
        </div>
    </div>

    <div v-else-if="!item" class="position-relative no-list-data">
        <ui-no-data-page text="Позиция каталога не найдена" />
    </div>

    <div v-else>
        <div class="page-title">{{ item.name }}</div>
        <div class="hr mb-4"></div>

        <div class="row">
            <div class="col-md-5 mb-4">
                <img v-if="item.image && item.loadingImg" class="w-100" :src="item.image" :alt="item.name" />

                <!-- пропорции — как у карточек каталога, чтобы блок не схлопывался во время загрузки -->
                <div v-else-if="item.image" style="position: relative; aspect-ratio: 1 / 0.75; background: #f5f5f5">
                    <div class="page-center">
                        <div class="page-center-box text-center">
                            <ui-loading-page />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-7 mb-4">
                <div class="grid-table grid-table_col-2 mb-3">
                    <div class="grid-table__item">Состояние</div>
                    <div class="grid-table__item">
                        <b>{{ item.type }}</b>
                    </div>
                    <template v-if="item.brand">
                        <div class="grid-table__item">Марка</div>
                        <div class="grid-table__item">
                            <b>{{ item.brand }}</b>
                        </div>
                    </template>
                    <template v-if="item.model">
                        <div class="grid-table__item">Модель</div>
                        <div class="grid-table__item">
                            <b>{{ item.model }}</b>
                        </div>
                    </template>
                    <template v-if="item.modification">
                        <div class="grid-table__item">Модификация</div>
                        <div class="grid-table__item">
                            <b>{{ item.modification }}</b>
                        </div>
                    </template>
                    <div class="grid-table__item">Полная стоимость</div>
                    <div class="grid-table__item">
                        <b>{{ priceMask(item.price) }}</b>
                    </div>
                </div>

                <p v-if="item.description">{{ item.description }}</p>

                <p v-if="item.url">
                    <a :href="item.url" target="_blank" rel="noopener">Страница с описанием у поставщика</a>
                </p>

                <!-- Оформление заявки: сервер считает расчёт по позиции и создаёт
                     лизинг, затем сразу переходим на заявку (без новой вкладки).
                     Доступно, когда у позиции задан тип предмета лизинга -->
                <ui-button v-if="item.leasing_subject_type" class="btn-base" :loading="creating" @click="createApplication">Оформить заявку</ui-button>
                <button v-else class="btn btn-base" disabled>Оформить заявку</button>
            </div>
        </div>

        <ui-modal v-if="modal.msg" :close="modalClose">
            <div class="modal-header">
                <h5 class="modal-title">{{ modal.title }}</h5>
                <button class="btn-close" type="button" @click="modalClose"></button>
            </div>
            <div class="modal-body">{{ modal.msg }}</div>
            <div class="modal-footer"></div>
        </ui-modal>
    </div>
</template>

<script>
import { getCatalogItem, createCatalogApplication } from './api'

export default {
    name: 'catalog-item',
    data() {
        return {
            loading: true,
            item: null,
            // оформляется ли сейчас заявка (спиннер на кнопке)
            creating: false,
            // модалка ошибки оформления заявки
            modal: {}
        }
    },
    methods: {
        priceMask(value) {
            return value ? value.toLocaleString('ru-RU') + ' ₽' : 'Цена по запросу'
        },
        // Оформление заявки: сервер по CalcID позиции создаёт расчёт и лизинг,
        // затем сразу переходим на созданную заявку в этой же вкладке
        async createApplication() {
            if (this.creating) return
            this.creating = true
            try {
                const response = await createCatalogApplication(this.item)
                if (response && response.status && response.leasingId) {
                    this.$router.push({
                        name: 'leasings.leasing.item',
                        params: { id: response.leasingId }
                    })
                    return
                }
                this.modal = {
                    title: 'Ошибка',
                    msg: (response && response.error) || 'Не удалось оформить заявку. Попробуйте позже.'
                }
            } catch (e) {
                this.modal = {
                    title: 'Ошибка',
                    msg: 'Не удалось оформить заявку. Попробуйте позже.'
                }
            } finally {
                this.creating = false
            }
        },
        modalClose() {
            this.modal = {}
        }
    },
    async mounted() {
        const response = await getCatalogItem(this.$route.params.id)
        if (response.status) {
            // предзагрузка картинки: loadingImg = true, когда изображение готово к показу;
            // менять флаг нужно через this.item (реактивный Proxy), иначе Vue не увидит
            this.item = { ...response.data, loadingImg: !response.data.image }
            if (this.item.image) {
                const img = new Image()
                img.onload = () => {
                    this.item.loadingImg = true
                }
                // не загрузилась — блок картинки просто скрывается, без вечного спиннера
                img.onerror = () => {
                    this.item.image = ''
                    this.item.loadingImg = true
                }
                img.src = this.item.image
            }
        }
        this.loading = false
    }
}
</script>
